import * as swcHelpers from '@swc/helpers';
import * as React from 'react';

const PaymentMethodFormContainer = ({ children , type , additionalOptions , checkout ,  })=>{
    const ref = React.useRef(null);
    // In order to properly unmount any mounted elements, the promise of the mounted element is used to
    // properly unmount it again whenever the cleanup cycle is triggered.
    React.useEffect(()=>{
        if (!checkout) {
            return;
        }
        const mountPayment = function() {
            var _ref = swcHelpers.asyncToGenerator(function*() {
                const c = yield checkout;
                const paymentMethod = c === null || c === void 0 ? void 0 : c.create(type, additionalOptions);
                var _current;
                return paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.mount((_current = ref.current) !== null && _current !== void 0 ? _current : '');
            });
            return function mountPayment() {
                return _ref.apply(this, arguments);
            };
        }();
        const promise = mountPayment();
        return ()=>{
            promise.then((component)=>{
                return component === null || component === void 0 ? void 0 : component.unmount();
            });
        };
    }, [
        type,
        additionalOptions,
        checkout
    ]);
    if (!checkout) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        ref: ref,
        className: "adyen-payment-method-form"
    }, children);
};

export { PaymentMethodFormContainer };
//# sourceMappingURL=PaymentMethodFormContainer.js.map
